<h1 mat-dialog-title>Bulk image delete</h1>
<mat-dialog-content>
  <p>You are about to delete {{ images.length }} images!</p>  
  <p>Are you sure you want to delete the selected images?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>

